// @flow
import { GoodSansB3 } from '@components/shared'
import { colors } from '@components/shared/colors'
import * as React from 'react'
import { Col, Container, Row, config, Hidden } from 'react-awesome-styled-grid'
import styled from 'styled-components'
import Badges from '@components/Badges'
import FullBleed from '@components/FullBleed'
import ThemeContext from '@components/shared/ThemeContext'

type PropsType = {
  children: React.Node,
  isFullBleed?: boolean
}

export function DriveToDownloadModule (props: PropsType): React.Node {
  if (props.isFullBleed) {
    return (
      <FullBleed>
        <Module>
          {props.children}
        </Module>
      </FullBleed>
    )
  }

  return (
    <Module>
      {props.children}
    </Module>
  )
}

const Module = (props: PropsType): React.Node => {
  const theme = React.useContext(ThemeContext)
  return (
    <ContainerDiv>
      <Container>
        <Row >
          <Col
            xs={4} sm={8} md={4} lg={5} xl={5}
            justify="center"
            offset={{ md: 0, lg: 1, xl: 1 }}
          >
            {props.children}
            <Download $theme={theme}>
              <Text $theme={theme}>Download the Dipsea app for the best listening experience.</Text>
              <BadgeContainer>
                <Badges badgesOnly={true} signup={false} webApp={false} containerStyles={{ marigin: 0 }} />
              </BadgeContainer>
            </Download>
          </Col>
          <Hidden xs sm >
            <Col md={4} lg={5} xl={5} align="center" justify="center">
              <PhoneImage src='/images/drive-to-download-full-device.png' />
            </Col>
          </Hidden>
        </Row>
      </Container>
    </ContainerDiv>
  )
}
const ContainerDiv = styled.div`
  padding: 40px 0;
  width: 100%;
`
const Text = styled.p`
  ${GoodSansB3};
    color: ${(props: any): string => props.$theme === 'pink' ? colors.white : colors.sand};
  flex:1;
  text-align: center;
  ${(props: any): string => config(props).media.md`
    text-align: left;
    min-width: 240px;
  `};
  ${(props: any): string => config(props).media.xl`
    max-width: 360px;
  `};
`
const BadgeContainer = styled.div`
  overflow: hidden;
  .badge-container {
    margin: -8px;
  }
`
const Download = styled.div`
  align-items: center;
  border-top: 1px solid ${(props: any): string => props.$theme === 'pink' ? colors.white : colors.sand};
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 2rem;
  ${(props: any): string => config(props).media.md`
    align-items: center;
    flex-wrap: wrap;
    flex-direction: row;
  `};
`
const PhoneImage = styled.img`
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: flex-end;
  img {
    width: 100%;
  }
  max-width: 220px;
  ${(props: any): string => config(props).media.lg`
    max-width: 310px;
  `};
`
